import { actionButton, actionIcon } from './styles';
import { Box } from '@material-ui/core';

import { Analytics } from '@cobliteam/analytics';
import { useOnboardingStore } from '@cobliteam/onboarding';

import {
  BookIcon,
  DropdownMenu,
  type DropdownOption,
  HelpIcon,
  LampFilledIcon,
} from '@cobliteam/base-components';

import Button from '@cobliteam/ui/components/Button';

import {
  HeadsetMicRounded,
  OpenInNew,
  SchoolRounded,
} from '@material-ui/icons';

const HowToUseDropdown = () => {
  const hasOnboarding = useOnboardingStore((state) => state.hasOnboarding);

  const dropdownMenuOptions = [
    {
      key: 'https://suporte.cobli.co/',
      value: 'Central de ajuda',
      icon: <HelpIcon />,
    },
    {
      key: 'https://app.livestorm.co/cobli-1',
      value: 'Ver treinamentos',
      icon: <SchoolRounded />,
    },
    {
      key: 'https://suporte.cobli.co/contato-cobli',
      value: 'Contato',
      icon: <HeadsetMicRounded />,
    },
  ];

  if (hasOnboarding) {
    dropdownMenuOptions.splice(2, 0, {
      key: '/onboarding',
      value: 'Guia de implementação',
      icon: <BookIcon />,
    });
  }

  const handleClick = (option: DropdownOption<string>) => {
    Analytics.track('How To Use Dropdown Option Clicked', {
      value: option.value,
    });
    window.open(option.key);
  };

  const handleOpenClientArea = () => {
    Analytics.track('Client area link clicked from the nav button');
    window.open('https://suporte.cobli.co/tickets-view');
  };

  return (
    <div className='flex flex-row items-center'>
      <Button
        onClick={handleOpenClientArea}
        variant='text'
        color='primary'
        size='condensed'
        startIcon={<OpenInNew className={actionIcon} />}
        className={actionButton}
      >
        Área do cliente
      </Button>
      <Box paddingRight={2}>
        <DropdownMenu
          disableMarginBetweenOptions
          options={dropdownMenuOptions}
          onClick={handleClick}
          divider={false}
          placement='bottom-end'
        >
          <Button variant='text' startIcon={<LampFilledIcon />}>
            Como usar?
          </Button>
        </DropdownMenu>
      </Box>
    </div>
  );
};

export default HowToUseDropdown;
